import { apiGet, apiGetText } from '../services/apiClient';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    qs.set(key, value);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

const authedGet = (path, token, params) => apiGet(`${path}${buildQuery(params)}`, token);
const authedGetCsv = (path, token, params) => apiGetText(`${path}${buildQuery(params)}`, token);

// Host endpoints
export const hostReportsMeta = (token) => authedGet('/api/host/reports/meta', token);
export const hostRevenue = (token, params) => authedGet('/api/host/reports/revenue', token, params);
export const hostOccupancy = (token, params) => authedGet('/api/host/reports/occupancy', token, params);
export const hostPropertyPerformance = (token, params) =>
  authedGet('/api/host/reports/property-performance', token, params);
export const hostTourPerformance = (token, params) =>
  authedGet('/api/host/reports/tour-performance', token, params);
export const hostExportReport = (token, params) => authedGetCsv('/api/host/reports/export', token, params);

// Admin endpoints
export const adminReportsMeta = (token, hostId) =>
  authedGet('/api/admin/reports/meta', token, hostId ? { hostId } : {});
export const adminRevenue = (token, params) => authedGet('/api/admin/reports/revenue', token, params);
export const adminOccupancy = (token, params) => authedGet('/api/admin/reports/occupancy', token, params);
export const adminPropertyPerformance = (token, params) =>
  authedGet('/api/admin/reports/property-performance', token, params);
export const adminTourPerformance = (token, params) =>
  authedGet('/api/admin/reports/tour-performance', token, params);
export const adminExportReport = (token, params) => authedGetCsv('/api/admin/reports/export', token, params);
export const adminTopHosts = (token, params) => authedGet('/api/admin/reports/top-hosts', token, params);
export const adminHostReports = (token, params) => authedGet('/api/admin/reports/hosts', token, params);
export const adminClientReports = (token, params) => authedGet('/api/admin/reports/clients', token, params);
